exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".task-question[data-v-78629c85]{width:100%;height:100%;position:relative}", "", {"version":3,"sources":["/workspace/src/views/order-review/pages/OrderReviewQuestionPanel/index.vue"],"names":[],"mappings":"AACA,gCAAgC,WAAW,YAAY,iBAAiB,CACvE","file":"index.vue","sourcesContent":["\n.task-question[data-v-78629c85]{width:100%;height:100%;position:relative\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78629c85","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order-review/pages/OrderReviewQuestionPanel/index.vue
// module id = 4736
// module chunks = 5